import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Component, Children } from 'react';
import { SANTA_MEMBERS_APP_ID } from '../../constants/applications';
import { EXPERIMENT_MEMBERS_AREA, EXPERIMENT_TOP_COMMENT } from '../../constants/experiments';
import { permissionsChecker } from '../../services/permissions-checker';
import { getCategory } from '../../selectors/categories-selectors';
import { getPost } from '../../selectors/post-selectors';
import { getApplicationConfig } from '../../selectors/communities-context-selectors';
import { isExperimentEnabled } from '../../selectors/experiments-selectors';
import withAuth from '../../hoc/with-auth';

class PermissionsProvider extends Component {
  constructor(props, context) {
    super(props, context);

    const store = props.store;
    const state = store.getState();

    const isMemberAreaInstalled = get(getApplicationConfig(store.getState(), SANTA_MEMBERS_APP_ID), 'isInstalled', false);
    const isMemberAreaEnabled = isExperimentEnabled(state, EXPERIMENT_MEMBERS_AREA);
    const isTopCommentExperimentEnabled = isExperimentEnabled(state, EXPERIMENT_TOP_COMMENT);
    const flags = { isMemberAreaInstalled, isMemberAreaEnabled, isTopCommentExperimentEnabled };
    this.permissions = permissionsChecker(flags, props.currentUser, resource => {
      if (resource.postId) {
        resource = getPost(store.getState(), resource.postId);
      }
      if (resource.categoryId) {
        resource = getCategory(store.getState(), resource.categoryId);
      }
      return resource;
    });
  }

  componentWillReceiveProps({ currentUser }) {
    this.permissions.setUserIdentity(currentUser);
  }

  getChildContext() {
    return { permissions: this.permissions };
  }

  render() {
    return Children.only(this.props.children);
  }
}

PermissionsProvider.propTypes = {
  store: PropTypes.object.isRequired,
  children: PropTypes.element.isRequired,
  currentUser: PropTypes.object,
};

PermissionsProvider.childContextTypes = {
  permissions: PropTypes.object.isRequired,
};

export default withAuth(PermissionsProvider);



// WEBPACK FOOTER //
// ./app/components/permissions-provider/permissions-provider.js